
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M9.276 6.992l4.523 4.523-1.9 1.9L7.376 8.89l-4.9 4.9-2.232-2.234 4.899-4.899L.585 2.101l1.9-1.9 4.557 4.557L11.557.244l2.233 2.233z"}})])
          )
        }
      }
    